var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-multi-select',{attrs:{"label":_vm.label,"value":_vm.value,"items":_vm.items,"fancy":_vm.fancy,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }